import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import SubTab from "../SubTab/SubTab";

const FutureWorkExperience = () => {
  const category = "FutureWorkExperience";
  const [dotCount, setDotCount] = useState(0);
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();
  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };

  // 점 애니메이션 (... 깜빡이는 효과)
  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev + 1) % 4);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const movePage = (path) => {
    navigate(path);
  };

  const containerStyle = {
    width: "100%",
    height: "60vh", // 🔹 세로 크기 줄임
    background: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    fontFamily: "'Pretendard', 'Noto Sans KR', sans-serif",
    color: "#202632",
    textAlign: "center",
    border: "1px solid #c9c9c9",
    borderRadius: "12px",
    marginBottom: "70px",
  };

  const logoStyle = {
    fontSize: "26px",
    fontWeight: "700",
    color: "#00a45a", // 🔹 포인트 녹색
    letterSpacing: "1px",
    marginBottom: "10px",
  };

  const titleStyle = {
    fontSize: "28px",
    fontWeight: "700",
    marginBottom: "10px",
  };

  const subStyle = {
    fontSize: "16px",
    color: "#555",
    marginBottom: "15px",
  };

  const dotWrapperStyle = {
    height: "30px", // 🔹 높이 고정 → 점 위치 고정
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    color: "#00a45a",
    fontWeight: "700",
    letterSpacing: "3px",
  };

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        <div className="sub_banner_area">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {"> "}사업분야{" > "}인재 양성 사업
            </div>
            <div className="banner_main_text">인재 양성 사업</div>
          </div>
        </div>
        <div className="navi_area">
          <div className="navi_back">
            <div
              className="navi_box business_field"
              onClick={() => handleSelect(1)}
            >
              <div className="navi_main_text">인재양성사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && "active"}`}>
                <div
                  className="select_row"
                  onClick={() => movePage("/fusionSupportProgram")}
                >
                  산학융합지구조성사업
                </div>
                <div
                  className="select_row"
                  onClick={() =>
                    movePage("/business/chungnamInnovationProject")
                  }
                >
                  기업지원사업
                </div>
                <div
                  className="select_row"
                  onClick={() =>
                    movePage("/business/localIndustryTalentDevelopment")
                  }
                >
                  인재양성사업
                </div>
                <div
                  className="select_row"
                  onClick={() => movePage("/business/dangjinStartupSupport")}
                >
                  창업육성사업
                </div>
              </div>
            </div>
            <div className="navi_box human" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">
                미래내일일경험(인턴형, 사전직무교육기관)
              </div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && "active"}`}>
                <div
                  className="select_row"
                  onClick={() =>
                    movePage("/business/localIndustryTalentDevelopment")
                  }
                >
                  지역산업맞춤형 인력양성사업
                </div>
                <div
                  className="select_row"
                  onClick={() => movePage("/business/koreanQuickStartProgram")}
                >
                  한국형 퀵스타트프로그램 사업
                </div>
                <div
                  className="select_row"
                  onClick={() => movePage("/business/smeResearchTalentSupport")}
                >
                  중소기업 연구인력 현장맞춤형 양성지원사업
                </div>
                {/* <div className="select_row" onClick={() => movePage('/business/chungnamIndustryAcademiaProgram')}>
                  충남산학융합형 인력양성사업
                </div> */}
                {/* <div
                  className="select_row"
                  onClick={() => movePage("/business/youthVentureProgram")}
                >
                  청년도전지원사업
                </div> */}
                <div
                  className="select_row"
                  onClick={() => movePage("/business/FutureWorkExperience")}
                >
                  미래내일일경험(인턴형, 사전직무교육기관)
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sub_main_area temporary">
          <SubTab category={category} />
          <div className="sub_main_back">
            <div style={containerStyle}>
              <div style={logoStyle}>충남산학융합원</div>
              <div style={titleStyle}>페이지 준비 중입니다.</div>
              {/* <div style={subStyle}>더 나은 서비스로 곧 찾아뵙겠습니다.</div> */}
              <div style={dotWrapperStyle}>{".".repeat(dotCount)}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FutureWorkExperience;
